import { useEffect, useState } from "react";
import {
  GetProviderTockenNetwork,
  getUserDetailByIdAction,
} from "../../../redux/actions/ProviderAssistAction";
import { useDispatch, useSelector } from "react-redux";
import ProfileDetail from "../../ServicePortal/ProfileDetail";
import ProfileVerification from "../../ServicePortal/ProfileVerification";
import InfrastructureDetails from "../../ServicePortal/InfrastructureDetails";
import StaffDetails from "../../ServicePortal/StaffDetails";
import Select from "react-select";
import { SearchIcon } from "../../../Utils/SvgIcons";
import HomePage from "../../ServicePortal/Home";
import { useLocation, useParams } from "react-router-dom";
import { getDispatch, getSnackbarSuccess } from "../../../Utils/helper";
import { GET_PROFILE_DETAILS, IS_PAGE_EDIT } from "../../../Utils/types";

const ProviderAssist = () => {
  const location = useLocation()
  const params = useParams()  
  localStorage.setItem("campaignsToken", params?.token);
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [tabName, setTabName] = useState("HomePage");
  const [searchFilter, setSearchFilter] = useState(null);
  const [providerList, setProviderList] = useState([]);

  useEffect(() => {
    if(location?.pathname ===  "/provider-assist"){
      const resp = dispatch(GetProviderTockenNetwork());
      resp.then((res) => {
        setProviderList(res?.data?.results);
      });
    }
  }, []);

  useEffect(() => {
    if (window.location.href?.includes("?")) {
      const url = window.location.href;
      const queryString = url
        ? url.split("?")[1]
        : window.location.search.slice(1);
      const queryString2 = url
        ? url.split("?")[2]
        : window.location.search.slice(2);
      const result = queryString2?.replace(/%20/gi, " ");
      setSearchFilter({
        ...searchFilter,
        providerId: Number(queryString),
        providerName: result,
      });
      setTimeout(() => {
        document.getElementById("searchbutton").click();
      }, 1000);
    }
    if(location.pathname !== "/provider-assist"){
      setShow(true)
      setTabName("ProfileDetail")
      getDispatch(GET_PROFILE_DETAILS, {}, dispatch);
    }
  }, []);

  const handleSearch = () => {
    getDispatch(IS_PAGE_EDIT, false, dispatch)
    if (searchFilter !== null && searchFilter?.providerName !== null) {
      const temp = providerList.filter(
        (ele) => ele?.providerId === searchFilter?.providerId
      )?.[0]?.providerToken;
      setShow(false);
      const resp1 = dispatch(getUserDetailByIdAction(temp));
      resp1.then((res) => {
        localStorage.setItem(
          "tempararyTokenProviderAssist",
          `Bearer ${res?.data?.results?.token}`
        );
        localStorage.setItem(
          "providerIdProviderPortal",
          res?.data?.results?.providerId
        );
        localStorage.setItem(
          "chainIdProviderPortal",
          res?.data?.results?.chainId
        );
        localStorage.setItem("ProviderPortalRole", res?.data?.results?.role);
        setShow(true);
        setTabName("HomePage");
      });
    }
  };

  const handleClearFilter = () => {
    setSearchFilter(null);
    setShow(false);
    setTabName("HomePage");
  };

  return (
    <div className={`main-section ${location?.pathname !==  "/provider-assist" ? "infraOpenUrl" :""}`}>
    <div className={`right-section ${location?.pathname !==  "/provider-assist" ? "infraOpenUrlRightSec" :""}`}  style={{ padding: "20px" }}>
      <div
        className="card staff-details-section"
        style={{ minHeight: "100vh" }}
      >
        <div className="card-body">
          {location.pathname === "/provider-assist" && <>
          <h4>Provider Assist</h4>
          <div className="row-filter">
            <Select
              className="basic-multi-select providerAsssitFilter"
              style={{ width: "300px" }}
              classNamePrefix="select"
              placeholder="Search Provider Name or Code"
              name="colors"
              isClearable={true}
              options={providerList?.map((ele) => {
                return {
                  value: ele?.providerId,
                  label: ele?.providerName,
                };
              })}
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              onChange={(e) => {
                setSearchFilter({
                  ...searchFilter,
                  providerId: e === null ? 0 : e?.value,
                  providerName: e === null ? e : e?.label,
                });
              }}
              value={
                searchFilter?.providerId
                  ? {
                      value: searchFilter?.providerId,
                      label: searchFilter?.providerName,
                    }
                  : null
              }
            />
            <button
              id="searchbutton"
              className="btn btn_export"
              type="button"
              onClick={handleSearch}
            >
              <SearchIcon /> Search
            </button>
            <button
              id="searchbutton"
              className="btn btn_export"
              type="button"
              onClick={handleClearFilter}
            >
              Clear All
            </button>
          </div>
          </>}
          {show && (
            <div className="providerassist_section">
              <div className="navbar" style={{ display: "flex" }}>
                {   location.pathname === "/provider-assist" && <button
                  type="button"
                  className={`${tabName === "HomePage" && "active"}`}
                  onClick={() =>
                    isPageEdit ? getSnackbarSuccess("warning","Please Save the Details",dispatch) :setTabName("HomePage")
                  }
                >
                  Home
                </button>} 
                <button
                  type="button"
                  className={`${tabName === "ProfileDetail" && "active"}`}
                  onClick={() =>
                    isPageEdit ? getSnackbarSuccess("warning","Please Save the Details",dispatch) :setTabName("ProfileDetail")
                  }
                >
                  Profile Details
                </button>
                <button
                  type="button"
                  className={`${tabName === "ProfileVerification" && "active"}`}
                  onClick={() =>
                    isPageEdit ? getSnackbarSuccess("warning","Please Save the Details",dispatch) :setTabName("ProfileVerification")
                  }
                >
                  Verification Details
                </button>
                <button
                  type="button"
                  className={`${
                    tabName === "InfrastructureDetails" && "active"
                  }`}
                  onClick={() =>
                    isPageEdit ? getSnackbarSuccess("warning","Please Save the Details",dispatch) :setTabName("InfrastructureDetails")
                  }
                >
                  Infrastructure Details
                </button>
                <button
                  type="button"
                  className={`${tabName === "StaffDetails" && "active"}`}
                  onClick={() =>
                    isPageEdit ? getSnackbarSuccess("warning","Please Save the Details",dispatch) :setTabName("StaffDetails")
                  }
                >
                  Staff Details
                </button>
              </div>
              {tabName === "HomePage" ? (
                <HomePage />
              ) : tabName === "ProfileDetail" ? (
                <ProfileDetail />
              ) : tabName === "ProfileVerification" ? (
                <ProfileVerification />
              ) : tabName === "InfrastructureDetails" ? (
                <InfrastructureDetails />
              ) : (
                tabName === "StaffDetails" && <StaffDetails />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
    </div>
  );
};

export default ProviderAssist;
